<template>
  <div class="row page-wrapper">
    <div class="col-12">
      <h1>404</h1>
      <h2>Entschuldigung, diese Seite wurde nicht gefunden.</h2>
      <router-link
        to="/"
        class="btn btn-outline-primary"
        title="Zurück zur Startseite"
        aria-label="Zurück zur Startseite"
      >
        Zurück zur Startseite
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound'
};
</script>

<style scoped>
    html {
        height: 100%;
    }

    body > div {
        height: 100%;
    }

    .page-wrapper {
        padding: 30px;
        background-color: #F8F9FA;
        height: 100%
    }

    .btn {
        margin-top: 10px;
    }

    h1 {
        font-size: 2.8rem !important;
        margin-bottom: 20px;
        color: #6C737D;
    }

    h2 {
        font-size: 1.5rem !important;
    }
</style>